import React from 'react';
/* @flow */
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectIsAuthenticated } from 'entities/auth/selectors';

type OwnProps = { isAuthenticated: boolean; render: (isAuthenticated: boolean) => any };
const Authenticated = ({ isAuthenticated, render }: OwnProps) => render(isAuthenticated);

export default connect(
  createStructuredSelector({
    isAuthenticated: selectIsAuthenticated,
  }) as () => { isAuthenticated: boolean }
)(Authenticated) as React.ComponentType<OwnProps>;
